const item = document.querySelectorAll('.js-theses-item');

function thesesInViewInit() {
    if (item.length > 0) {
        item.forEach((element) => {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (!entry.isIntersecting) {
                            entry.target.classList.remove('is-in-view');
                        } else {
                            entry.target.classList.add('is-in-view');
                        }
                    });
                },
                {
                    rootMargin: '-50% 0% -50% 0%',
                    threshold: 0,
                },
            );
            observer.observe(element);
        });
    }
}

function thesesInit() {
    thesesInViewInit();
}

function init() {
    thesesInit();
}

const _module = { init };

export default _module;
